var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinSpot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "#adadad",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.68,65.63C186.23,55.41,159,50,128,50S69.77,55.41,49.32,65.63C29.41,75.58,18,89.57,18,104v48c0,14.43,11.41,28.42,31.32,38.37C69.77,200.59,97,206,128,206s58.23-5.41,78.68-15.63C226.59,180.42,238,166.43,238,152V104C238,89.57,226.59,75.58,206.68,65.63Zm-152,10.74C73.21,67.1,99.25,62,128,62s54.79,5.1,73.32,14.37C217,84.21,226,94.28,226,104s-9,19.79-24.68,27.63C182.79,140.9,156.75,146,128,146s-54.79-5.1-73.32-14.37C39,123.79,30,113.72,30,104S39,84.21,54.68,76.37ZM122,157.93v36c-19.24-.48-37.07-3.28-52-8.11v-35.4C85.27,154.93,102.85,157.49,122,157.93Zm12,0c19.15-.44,36.73-3,52-7.52v35.4c-14.93,4.83-32.76,7.63-52,8.11ZM30,152V129a76,76,0,0,0,19.32,13.36q4.16,2.07,8.68,3.88v35c-1.13-.52-2.24-1-3.32-1.58C39,171.79,30,161.72,30,152Zm171.32,27.63c-1.08.54-2.19,1.06-3.32,1.58v-35q4.51-1.81,8.68-3.88A76,76,0,0,0,226,129v23C226,161.72,217,171.79,201.32,179.63Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinSpot);
export default __webpack_public_path__ + "static/media/coin-spot.6f8b3252.svg";
export { ForwardRef as ReactComponent };